import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    uomList: [],
};

const getters = {
    uomList: state => state.uomList,
};

const mutations = {
    setUomList(state, data) {
        state.uomList = data;
    },
};

const actions = {
    async getUomList({ commit, dispatch }) {
        let route = Laroute.route('franchise.uom.list');

        startLoading(dispatch, 'list');

        return axios
            .get(route)
            .then(res => {
                commit('setUomList', res.data);
                endLoading(dispatch, 'list');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'list');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
